exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".display[data-v-97dda0b6]{display:flex;justify-content:space-between}.display .outdated[data-v-97dda0b6]{color:#228b22}.display .current[data-v-97dda0b6]{color:#ada4a4}", ""]);

// exports
